import React from 'react';
import { BehaviorSubject } from 'rxjs';
import generatePDF from 'react-to-pdf';

export const pdfDownloaded = new BehaviorSubject(false);

export const pdfIsDownloading = (newState: boolean) => {
	pdfDownloaded.next(newState);
};

// función para generar el PDF
export const handleGeneratePDF = (
	targetRefPDF: React.RefObject<HTMLDivElement>,
	setIsReady: React.Dispatch<React.SetStateAction<boolean>>,
	filename: string,
) => {
	pdfIsDownloading(true);
	setIsReady(true);
	setTimeout(() => {
		const pdfPromise = generatePDF(targetRefPDF, { filename: filename });
		if (pdfPromise && typeof pdfPromise.then === 'function') {
			pdfPromise.then(() => {
				pdfIsDownloading(false);
				setIsReady(false);
			});
		} else {
			pdfIsDownloading(false);
			setIsReady(false);
		}
	}, 100);
};
